const workspaceConnected = (state) => {
  return state.workspace.connected
}

export { workspaceConnected }
